import { render, staticRenderFns } from "./block-banner-home.vue?vue&type=template&id=1c67a1d9&scoped=true"
import script from "./block-banner-home.vue?vue&type=script&lang=js"
export * from "./block-banner-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67a1d9",
  null
  
)

export default component.exports